import Enum from '@/modules/core/app/helpers/Enum';

export class EstateProductType extends Enum {
  static SETTLEMENT = {
    key: 'settlement'
  };

  static PLANNING = {
    key: 'planning'
  };
}
